const MODEL_VIEWER_SRC = "/vendor/model-viewer.min.js";

let loadPromise = null;

/**
 * Load model-viewer from same-origin static file (works when Google CDN is blocked).
 * @returns {Promise<void>}
 */
export function loadModelViewer() {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("loadModelViewer is client-only"));
  }

  if (typeof customElements !== "undefined" && customElements.get("model-viewer")) {
    return Promise.resolve();
  }

  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.type = "module";
    script.src = MODEL_VIEWER_SRC;
    script.onload = () => {
      if (typeof customElements === "undefined") {
        reject(new Error("customElements unavailable"));
        return;
      }
      customElements.whenDefined("model-viewer").then(resolve).catch(reject);
    };
    script.onerror = () => reject(new Error("Failed to load model-viewer script"));
    document.head.appendChild(script);
  });

  return loadPromise;
}
